import ActiveRecord from './active_record/base'

class Organisation extends ActiveRecord {
	static tableName = 'organisations'
	static sort = 'name'
}

export default Organisation
